import mitt from 'mitt'

/**
 * 消息事件总线
 * 用于 IM 消息的分发和处理
 */
export const messageEventBus = mitt()

/**
 * 派发消息事件
 * @param {string} msgType - 消息类型
 * @param {Object} data - 消息数据
 */
export function emitMessage(msgType, data) {
  messageEventBus.emit(msgType, {
    msgType,
    data,
    timestamp: Date.now()
  })
}

/**
 * 监听消息事件
 * @param {string} msgType - 消息类型
 * @param {Function} handler - 处理函数
 */
export function onMessage(msgType, handler) {
  messageEventBus.on(msgType, handler)
}

/**
 * 移除消息监听
 * @param {string} msgType - 消息类型
 * @param {Function} handler - 处理函数
 */
export function offMessage(msgType, handler) {
  messageEventBus.off(msgType, handler)
}

/**
 * 监听所有消息（用于调试）
 * @param {Function} handler - 处理函数
 */
export function onAllMessages(handler) {
  messageEventBus.on('*', handler)
}

/**
 * 清空所有监听器
 */
export function clearAllMessageListeners() {
  messageEventBus.all.clear()
}
